module.exports = __webpack_public_path__ + "static/media/to-do.c0fe7842.svg";